import { render } from "./CurvedCornersImage.vue?vue&type=template&id=38b8e5a0"
import script from "./CurvedCornersImage.vue?vue&type=script&lang=js"
export * from "./CurvedCornersImage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__